import { Text } from '@uhg-abyss/web/ui/Text';
import { getEEMSURL } from '@src/env.config';

export const ErrorPage = () => {
  return (
    <Text
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '5px',
        width: '100%',
      }}
    >
      <br />
      <Text
        css={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          color: 'blue',
          fontWeight: 'bold',
          fontSize: '18px',
          height: '50vh',
        }}
      >
        User is invalid .. For any queries please reach out to{' '}
        <a href="mailto:E3_OM_DL@ds.uhc.com"> E3_OM_DL@ds.uhc.com</a>
      </Text>
    </Text>
  );
};
